var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapsAndFlags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.108,
    height: 25,
    viewBox: "0 0 18.108 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d2d2d2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70.573)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.573)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.627,0a9.064,9.064,0,0,0-9.054,9.054c0,6.2,8.1,15.291,8.447,15.676a.816.816,0,0,0,1.213,0c.345-.384,8.447-9.48,8.447-15.676A9.064,9.064,0,0,0,79.627,0Zm0,13.609a4.555,4.555,0,1,1,4.555-4.555A4.56,4.56,0,0,1,79.627,13.609Z",
    transform: "translate(-70.573 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsAndFlags);
export default __webpack_public_path__ + "static/media/maps-and-flags.9929c41a.svg";
export { ForwardRef as ReactComponent };